module.exports = __webpack_public_path__ + "media/video.a22b1d8d.mp4";